module.exports = {
  content: {
    popularRecommendation: "Popular Recommendation",
    buy: "Buy",
    aboutEMarket: "About YayTech",
    aboutUs: "About us",
    registerSeller: "Sellers - register to sell",
    sellerPortal: "Seller Portal",
    help: "Help",
    FAQs: 'FAQs',
    customerService: "Policies and Terms",
    termsConditions: "Terms of Use",
    privacyPolicy: "Privacy Policy",
    shippingPolicy: "One-Year Limited Warranty",
    afterSalespolicy: "After-sales policy",
    limitedWarranty: "One-Year Limited Warranty",
    contactUs: "Contact Us",
    phone: "800-893-9598,Mon - Fri: 8am - 5pm (PST)",
    address: "13771 Norton Ave, Chino, CA 91710",
    link: "support@xxxx.com",
    copy: "© Copyright 2021. All rights reserved.",
  },
  subscribe: {
    title: "NEW TO YayTech?",
    dec: "Subscribe to our newsletter to get updates on our latest offers!",
    btn: "Subscribe",
    text: "Enter email address",
    paytitle: "PAYMENT METHODS",
    payText: "Payments 100% secured",
    FollowUsNow: 'Follow us now'
  },
  comment: {
    customerReviews: "Customer Reviews",
    dec: "YayTech is a safe, simple marketplace for buying used tech.",
    content: `Hi! We are YayTech, a leading second-hand electronic equipment market. Our mission? By giving professional testing or <br /> repairing equipment a second life, our ultimate dream of "a world without electronic waste landfills" is realized.`
  },
  MainHomePage: {
    Shipping: 'Today\'s Deals – All With Free Shipping',
    Recommendation: 'Popular Product Recommendation',
    stores: 'Today\'s Recommended Stores',
    EMarket: 'Who is YayTech?',
    Guarantee: 'Our Guarantee',
    Payments: 'Payments 100% Secured',
    guarantee: '30-Day Money Back Guarantee',
    warranty: '1-Year Minimum Warranty',
    FreeShipping: 'Free Shipping',
    Cellphone: 'Phones',
    iPad: 'IPad',
    Tablets: 'Tablets',
    Laptops: 'Laptops',
    Macs: 'Macs',
    Introduction: 'Why YayTech',
    Huachuang: 'YayTech is making refurbished tech cool again. Consumers are becoming increasingly aware of the long-term impact that the constant consumption of new technology is having on the environment. More and more people are looking to refurbished devices for both a better price and because extending any product lifecycle means that its no longer heading for a landfill or our oceans. YayTech is committed to providing the best possible value for every product on offer. Each and every product is diligently and meticulously refreshed to make it like new once more. Additionally, YayTech shoppers will find one of the widest assortments of products on the market and devices bought on YayTech will have the lowest price, fast shipping and a guaranteed free return. And if anything doesn’t work out, we will repair the device free of charge for up to 1-year after the initial purchase. Suffice to say, there are a lot of reasons to say ‘Yay!’ to YayTech. ',
    electronic: 'All electronic products on the YayTech platform have undergone strict quality inspection, professional repair or refurbishment. Here you can enjoy a 50-80% discount on electronic products!',
    partners: 'Our partners are electronics experts who test and verify that each product is 100% functional before it leaves the factory.',
    hassle_free: '30-day hassle-free returns',
    Once: 'Once you receive your item, you have 30 days to give it a test run. If it doesn’t meet your expectations, return it. Simple as that.',
    shipping: 'Free shipping',
    Almost: 'Almost all products have free shipping. So you pay for what you want instead of paying for shipping.',
    refurbisher: '12-months refurbisher warranty',
    replace: 'In case of a defect, the item can be repaired free of charge. If it cannot be repaired, we will replace it.',
    support: 'Customer care support',
    business: 'If you have any questions or problems, our business will reply to you within 1 business day. If we dont, we ve got your back and well help you to resolve it.'
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en-us/footer.js